import { validationErrors } from "../utils";
import ajaxService from "./ajax-service";

class TransactionService {
  async fetch(page, perPage) {
    const response = await ajaxService.get(
      `/accounts/browse-transactions?page=${page}&perPage=${perPage}`
    );
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async viewTransaction(id) {
    const response = await ajaxService.get(
      `/accounts/browse-transactions/${id}`
    );
    if (response ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
  async editTransaction(id, data) {
    const response = await ajaxService.post(
      `/accounts/browse-transactions/`,
      data,
      id
    );
    if (response?.success ?? false) {
      return response;
    } else {
      const errors = response.data.errors;
      return validationErrors(errors);
    }
  }
}

const transactionService = new TransactionService();
export default transactionService;
